// ABOUTME: Typed tRPC client setup with Supabase JWT authentication.
// ABOUTME: Provides React hooks integration via createTRPCReact.

import { httpLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { supabase } from '@/lib/supabase';
import type { AppRouter } from '@reflow/api-service/trpc';

function getBaseUrl(): string {
    const configured = import.meta.env.VITE_API_URL as string | undefined;
    if (!configured || configured.trim() === '') {
        return '';
    }
    return configured;
}

export const baseUrl = getBaseUrl();
const trpcUrl = `${baseUrl}/api`;

async function getHeaders(): Promise<Record<string, string>> {
    const { data: { session } } = await supabase.auth.getSession();
    const accessToken = session?.access_token;
    if (!accessToken) {
        return {};
    }

    return {
        Authorization: `Bearer ${accessToken}`,
    };
}

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
    links: [
        httpLink({
            url: trpcUrl,
            headers: getHeaders,
            methodOverride: 'POST',
        }),
    ],
});
